module.exports = __webpack_public_path__ + "static/media/table_column_resize_small.1e09300e.png";